import wootConstants from 'dashboard/constants/globals';

const ALL_CONVERSATIONS_ROUTE_NAMES = ['home', 'inbox_conversation'];

export const resolveInitialAssigneeTab = ({
  routeName,
  availableTabs = [],
  fallbackTab = wootConstants.ASSIGNEE_TYPE.ME,
}) => {
  const availableKeys = availableTabs.map(tab => tab.key);
  const resolvedFallback = availableKeys.includes(fallbackTab)
    ? fallbackTab
    : availableKeys[0] || fallbackTab;

  if (!ALL_CONVERSATIONS_ROUTE_NAMES.includes(routeName)) {
    return resolvedFallback;
  }

  return availableKeys.includes(wootConstants.ASSIGNEE_TYPE.ALL)
    ? wootConstants.ASSIGNEE_TYPE.ALL
    : resolvedFallback;
};
